<template lang="pug">
  .scene.tac.pos-a(:class='isShowScene ? "animated bounceInUp" : "animated bounceOutDown"')
    slider(v-if='getVideoSceneList', :data='getVideoSceneList', :scrollX='true')
      .list(ref='sceneList')
        .item(
          v-for='(scene, index) in getVideoSceneList',
          @click='switchScene(index, scene.scene_id, scene.file_url)')
          el-tooltip(effect='dark', :content='scene.dec', placement='top', :disabled='!scene.dec')
            .inner(:class='{"active": curIndex === index}')
              //- .ctrl-bar.pos-a
              //-   span.icon.edit(@click.stop='showDesc(scene.dec)')
              //-     i.iconfont.icon-redian
              .img-box.pos-a
                img(:src='scene.pic_url')
              .info.pos-a
                p.title.omit {{ scene.scene_name }}
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import sceneMixin from '@/mixins/scene'
import { NEXT_VIDEO, CHANGE_SCENE } from '@/config/contant'

export default {
  name: 'scene',
  mixins: [sceneMixin],
  data() {
    return {
      baseUrl: window.$globalconfig.URLS.API,
      isShow: true,
      curIndex: 0,
      sceneObj: null,
    }
  },
  mounted() {
    this.emitNextVideo()
  },
  computed: {
    ...mapGetters([
      'isShowScene',
      'getVideoInfo',
      'getVideoSceneList',
      'getSelectedSceneImage',
    ]),
  },
  methods: {
    ...mapActions({
      delVideoScene: 'VIDEO_SCENE_DELETE',
      fetchVideoHotspots: 'VIDEO_SCENE_HOTSPOTS',
    }),
    emitNextVideo() {
      this.$vgo.on(NEXT_VIDEO, () => {
        if (this.curIndex < this.getVideoSceneList.length - 1) {
          this.curIndex++
        } else {
          this.curIndex = 0
        }
        const sceneId = this.getVideoSceneList[this.curIndex].scene_id
        const url = this.getVideoSceneList[this.curIndex].file_url
        this.$vgo.emit(CHANGE_SCENE, { sceneId, url })
      })
    },
    initWidth() {
      const { sceneList } = this.$refs
      const item = sceneList.children[0]
      let width = 0
      for (let i = 0; i < this.getVideoSceneList.length; i++) {
        width += item.offsetWidth
      }
      sceneList.style.width = width + 'px'
    },
    delScene(_id) {
      this.$vgo.open(() => {
        this.delVideoScene(_id)
      })
    },
    switchScene(index, sceneId, url) {
      this.curIndex = index
      this.$vgo.emit(CHANGE_SCENE, { sceneId, url })
    },
  },
  getVideoInfo(data) {
    if (data && !data.ispass) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.initWidth()
        }, 1000)
      })
    }
  },
}
</script>
<style lang="stylus" scoped>
@import '~assets/styles/colors.styl'
@import '~assets/styles/variables.styl'
$itemWidth = 5rem
.scene
  bottom: 50px
  width: 100%
  bottom: 55px
  z-index: $--zindex-low
  .list
    min-width: 100%
    .item
      display: inline-block
      padding: 5px
      cursor: pointer
      overflow: hidden
      .inner
        position: relative
        width: $itemWidth
        height: $itemWidth
        border-radius: 3px
        box-sizing: border-box
        &.active
          border: 1px solid $--theme-color
          .info .title
            color: $--theme-color
    .img-box
      width: 100%
      height: 100%
      border-radius: 3px

    .info
      bottom: 0
      left: 0
      right: 0
      padding: 0 3px
      height: 20px
      line-height: 20px
      background-color: rgba($--color-black, .2)
      overflow: hidden
      z-index: $--zindex-low
      .title
        margin: 0
        font-size: 12px
        color: $--color-white

    .ctrl-bar
      right: 0
      top: 0
      z-index: 10
      .icon
        display: inline-block
        width: 20px
        height: 20px
        margin-right: 2px
        text-align: center

@media (max-width: 414px)
  .scene
    .list
      .item
        .inner
          width: 4rem
          height: 4rem
</style>
